import { render, staticRenderFns } from "./AppointmentsDrawer.vue?vue&type=template&id=6058c4f5&"
import script from "./AppointmentsDrawer.vue?vue&type=script&lang=js&"
export * from "./AppointmentsDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports